const findPwd = {
  name: 'findPwd',
  path: 'find-pwd',
  component: resolve => require(['../../../pages/custom/find-pwd'], resolve)
}

export default findPwd
